import BlueButton from '../../components/blue-button';
import CountUp from '../../components/countup';
import {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {navigate} from '../../../utils/navigation';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';

import TapIcon from './tap-icon';
import AddIcon from './add-icon';

export default ({index}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__bounceInUp');
            modal.current.classList.add('animate__bounceOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('mobile-app')); 
            
            if(trigger === 'close')
                closePromotionModal('mobile-app');
            else
                clickPromotionModal('mobile-app', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix mobile-app">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__bounceInUp animate__faster" ref={modal}>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="mobile-app-image"></div>
                            <div className="mobile-app-title">Add <span>Lucksy</span> to your<br/>Home Screen</div>
                            <div className="mobile-app-text">1. Tap <TapIcon /> in the bottom bar</div>
                            <div className="mobile-app-text">2. Select <AddIcon /> <span>Add to Home Screen</span></div>
                            <div className="mobile-app-tap animate__animated animate__pulse animate__infinite">
                                <span>
                                    Tap
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_2371_12173)">
                                            <path d="M16.6716 8.32227C22 8.32227 22 8.335 22 13.4397V17.3223C22 24.3223 22 24.3223 16.6716 24.3223H8C2 24.3223 2 24.3223 2 17.3223V13.4397C2 8.33496 2 8.33496 7.24435 8.33496" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M12 17.3223L12 3.32227" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15.3499 5.17227L11.9999 1.82227L8.6499 5.17227" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2371_12173">
                                                <rect width="24" height="25" fill="white" transform="translate(0 0.322266)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <svg width="90" height="50" viewBox="0 0 90 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M68.5 0C80.3741 0 90 9.62588 90 21.5C89.9997 33.3739 80.374 43 68.5 43H53.9946C53.5422 43 53.1032 43.1534 52.7492 43.435L45.7451 49.0088C45.0162 49.5888 43.9838 49.5888 43.2549 49.0088L36.2508 43.435C35.8968 43.1534 35.4578 43 35.0054 43H21.5C9.62604 43 0.000259775 33.3739 0 21.5C0 9.62588 9.62588 3.22136e-08 21.5 0H68.5Z" fill="#4FACFE"/>
                                    <path d="M68.5 0C80.3741 0 90 9.62588 90 21.5C89.9997 33.3739 80.374 43 68.5 43H53.9946C53.5422 43 53.1032 43.1534 52.7492 43.435L45.7451 49.0088C45.0162 49.5888 43.9838 49.5888 43.2549 49.0088L36.2508 43.435C35.8968 43.1534 35.4578 43 35.0054 43H21.5C9.62604 43 0.000259775 33.3739 0 21.5C0 9.62588 9.62588 3.22136e-08 21.5 0H68.5Z" fill="url(#paint0_linear_2371_12168)"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_2371_12168" x1="-4.06015" y1="64.2769" x2="130.182" y2="36.9459" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#4FACFE"/>
                                            <stop offset="1" stop-color="#00D1DB"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}